import { render, staticRenderFns } from "./ChartLabels.vue?vue&type=template&id=24d4b50a&scoped=true&"
import script from "./ChartLabels.vue?vue&type=script&lang=js&"
export * from "./ChartLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d4b50a",
  null
  
)

export default component.exports